import { render, staticRenderFns } from "./faceDetail.vue?vue&type=template&id=0c9936f4&scoped=true"
import script from "./faceDetail.vue?vue&type=script&lang=js"
export * from "./faceDetail.vue?vue&type=script&lang=js"
import style0 from "./faceDetail.vue?vue&type=style&index=0&id=0c9936f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9936f4",
  null
  
)

export default component.exports